var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import { Component } from "vue-property-decorator";
let Navigation = class Navigation extends Vue {
    items = [
        { title: 'Dashboard', icon: 'mdi-view-dashboard', link: "dashboard" },
        { title: 'Monitor', icon: 'mdi-image', link: "monitor", target: "_blank" },
        { title: 'Benutzer Verwaltung', icon: 'mdi-help-box', link: "$router.push(`/userlist`)" },
    ];
    logout() {
        this.$store.commit('logout');
    }
    userHasRole(role) {
        return this.$store.getters.userHasRole(role);
    }
    openMonitoring() {
        let routeData = this.$router.resolve({ name: 'Monitoring' });
        window.open(routeData.href, '_blank');
    }
    openMonitor() {
        let routeData = this.$router.resolve({ name: 'Monitor' });
        window.open(routeData.href, '_blank');
    }
};
Navigation = __decorate([
    Component({
        name: 'Navigation'
    })
], Navigation);
export default Navigation;
